import InitialState from "./InitialState";
import { SET_FLAG } from "../CONSTANTS";
// import Partner from "../schema/types/Partner";

export default function reducer(state = new InitialState(), action) {
  switch (action.type) {
    case SET_FLAG: {
      return state.set(action.payload.key, action.payload.value);
    }

    // case "USER_LOGOUT": {
    //   return new InitialState();
    // }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/reducer/reducer.js